import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PasswordGate from './components/PasswordGate';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PasswordGate>
      <App />
    </PasswordGate>
  </React.StrictMode>
);
